import { Input } from "antd";
import { TextAreaProps } from "antd/es/input";
import { FC } from "react";

type AppTextAreaProps = TextAreaProps & {
    resize?: React.CSSProperties["resize"];
};

export const AppTextArea: FC<AppTextAreaProps> = ({
    style,
    resize = "none",
    ...rest
}) => {
    return (
        <Input.TextArea
            style={{ fontFamily: "inherit", resize, ...style }}
            {...rest}
        />
    );
};
